import { UITrackEventPayload } from '@atlassian/community-library';

export const getButtonEventPayload = (
  action: string,
  actionSubjectId: string,
  source: string,
  href: string,
  label: string,
): UITrackEventPayload => {
  return {
    action,
    actionSubject: 'button',
    actionSubjectId: actionSubjectId,
    source: source,
    attributes: {
      href,
      label,
    },
  } as UITrackEventPayload;
};
